import { Box } from '@mui/material';
import { OrgIcon } from './OrgIcon';

export const ORG_COLORS = [
  '#2E7D32',
  '#6A1B9A',
  '#1565C0',
  '#AD1457',
  '#00695C',
  '#E65100',
  '#4527A0',
  '#283593',
];

interface Props {
  name: string;
  color?: string;
}

export function OrgAvatar({ name, color }: Props) {
  const initial = name.slice(0, 1).toUpperCase();
  const appliedColor = color ?? 'primary.main';

  return (
    <Box sx={{ position: 'relative', width: 32, height: 32, flexShrink: 0 }}>
      <Box
        sx={{
          width: 32,
          height: 32,
          backgroundColor: appliedColor,
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 20,
          fontWeight: 500,
          color: 'white',
          lineHeight: '28px',
        }}
      >
        {initial}
      </Box>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: -2,
          width: 12,
          height: 12,
          backgroundColor: 'white',
          border: '2px solid white',
          borderRadius: '2px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <OrgIcon sx={{ width: 10, height: 10, color: appliedColor }} />
      </Box>
    </Box>
  );
}
